import { createClient, type SupabaseClient } from "@supabase/supabase-js";

// Browser client. Uses the public anon key — data is protected by row-level security.
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const cloudConfigured = !!(url && anon && !url.includes("YOUR-PROJECT"));

export const supabase: SupabaseClient = cloudConfigured
  ? createClient(url!, anon!, { auth: { persistSession: true, autoRefreshToken: true, storageKey: "mytv.sb.session" } })
  : (null as unknown as SupabaseClient);

// Usernames are the identity in this app; Supabase Auth wants an email, so each
// username maps to a fixed internal address (never emailed — accounts are created confirmed).
export const emailFor = (username: string) => `${username.trim().toLowerCase()}@users.mytv.app`;
